/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Basin_AreaInputs */

const cs_form_basin_area = /** @type {(inputs: Form_Basin_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bazén (m²)`)
};

const en_form_basin_area = /** @type {(inputs: Form_Basin_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pool area (m²)`)
};

/**
* | output |
* | --- |
* | "Pool area (m²)" |
*
* @param {Form_Basin_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_basin_area = /** @type {((inputs?: Form_Basin_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Basin_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_basin_area(inputs)
	return cs_form_basin_area(inputs)
});